// OK 05/11/2024

import { Logement } from "../interfaces";
import { ObjectId } from "../types";
import {  ip } from "../utils/setup";

const LOGEMENT_API = `${ip}/api/Logements`;

// GET

export async function getLogements(): Promise<Logement[]> {
    const response = await fetch(LOGEMENT_API, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(
      `Connexion au serveur impossible, code serveur: ${response.status}`
    );
  }
}

// GET ID

export async function getLogement(_id: ObjectId): Promise<Logement> {
    const response = await fetch(`${LOGEMENT_API}/${_id}`, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur du serveur lors de la réception du logement");
  }
}

// POST

export async function createLogement(
  newLogement: Partial<Logement>
): Promise<Logement> {
  const response = await fetch(LOGEMENT_API, {
      method: "POST",
      credentials: "include" ,
    headers: {
        "content-type": "application/json",
        
    },
    body: JSON.stringify(newLogement),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(" Erreur lors de la création du nouveau logement");
  }
}

//PUT

export async function updateLogement(updateLogement: Logement) {
  const { globalError, ...restLogement } = updateLogement;
  const response = await fetch(`${LOGEMENT_API}/${restLogement.idLog}`, {
      method: "PUT",
      credentials: "include" ,
      headers: {
          "Content-Type": "application/json",
         
      },
    body: JSON.stringify(restLogement),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition du logement");
  }
}

// DELETE

export async function deleteLogement(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${LOGEMENT_API}/${_id}`, {
      method: "DELETE",
      credentials: "include" 
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error("Erreur lors de la suppression du logement ");
  }
}
